import { FaExclamationTriangle } from 'react-icons/fa';
import { getLocalDateString } from '../../utils/dateUtils';

const CompletionModal = ({
  isFixedFee,
  completionDate,
  setCompletionDate,
  saving,
  onCancel,
  onConfirm,
}) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-xl p-6 w-full max-w-md">
        <h4 className="text-lg font-semibold mb-4 text-gray-800">Confirm Job Completion</h4>
        {!isFixedFee && (
          <p className="text-sm text-yellow-700 bg-yellow-100 p-3 rounded mb-4 border border-yellow-300">
            <FaExclamationTriangle className="inline mr-1" />
            Once marked complete, your Actual Hours cannot be changed. To fulfill your resource allocation, set or leave status as APPROVED and save today's hours.
          </p>
        )}
        <div className="mb-4">
          <label htmlFor="completionDate" className="block text-sm font-medium text-gray-700 mb-1">
            Completion Date
          </label>
          <input
            type="date"
            id="completionDate"
            value={completionDate}
            max={getLocalDateString()}
            onChange={(e) => setCompletionDate(e.target.value)}
            className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
          />
        </div>
        <div className="flex justify-end space-x-3">
          <button
            onClick={onCancel}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-200 border border-gray-300 rounded-md shadow-sm hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-400"
            disabled={saving}
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 disabled:opacity-50"
            disabled={saving || !completionDate}
          >
            {saving ? (
              <>
                <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Saving...
              </>
            ) : (
              'Confirm Completion'
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CompletionModal;
